<template>
  <svg
    width="49"
    height="26"
    viewBox="0 0 49 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 13C3 13 6.18519 23 13.75 23C21.3148 23 24.5 13 24.5 13C24.5 13 27.6852 3.00012 35.25 3C42.8148 2.99988 46 13 46 13"
      class="stroke-blue-20"
      stroke-width="5"
    />
  </svg>
</template>
